import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestAssignPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestAssignPage/QuoteRequestAssignPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign')(
    {
        staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
        validateSearch: stringSearch({ storageKey: 'optional' }),
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    const storageKey = Route.useSearch({ select: (search) => search.storageKey });
    return <QuoteRequestAssignPage context={{ type: 'NegotiationV2', id: negotiationId }} storageKey={storageKey} />;
}
